import Swiper, { Navigation, Pagination } from 'swiper';

export default {
  init() {
    // JavaScript to be fired on the home page
      Swiper.use([Pagination, Navigation]);
     new Swiper ('.carousel', {
        speed: 400,
        //truewrapper adoptsheight of active slide
        autoHeight: false,
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        // delay between transitions in ms
        autoplay: 5000,
        autoplayStopOnLast: false, // loop false also
        // If we need pagination
        pagination: '.swiper-pagination',
        paginationType: 'bullets',

            // Navigation arrows
        navigation: {
           nextEl: '.cqf-swiper-button-next',
           prevEl: '.cqf-swiper-button-prev',
         },

         breakpoints: {
           768: {
             slidesPerView: 1,
           },
           1200: {
             slidesPerView: 4,
           },
         },

        // And if we need scrollbar
        //scrollbar: '.swiper-scrollbar',
        // "slide", "fade", "cube", "coverflow" or "flip"
        effect: 'slide',
        // Distance between slides in px.
        spaceBetween: 60,
        //
        //
        centeredSlides: true,
        //
        slidesOffsetBefore: 0,

      })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateOffer.js